<div class="rs-panel-flex" data-cy="norton360MySubscriptionSection">
  <div class="rs-panel-flex-cell rs-bg-grey1 rs-flex rs-flex-dir-col">
    <h2 class="rs-tit5">{{ 'norton360.subscriptions.title' | translate }}</h2>
    <div class="rs-flex-row">
      <div class="rs-flex-columns small-12 medium-6">
        <div class="rs-panel-flex">
          <div class="rs-panel-flex-cell rs-bg-c2 rs-flex rs-flex-dir-col">
            <p id="product0-title" data-cy="norton360MySubsciptionNorton1Name">
              <strong> {{ norton1Name }} </strong>
            </p>
            <ul aria-labelledby="product0-title" [innerHTML]="getDescriptionNorton1()"></ul>
          </div>
        </div>
      </div>
      <div class="rs-flex-columns small-12 medium-6">
        <div class="rs-panel-flex">
          <div class="rs-panel-flex-cell rs-bg-c2 rs-flex rs-flex-dir-col">
            <p id="product1-title" data-cy="norton360MySubsciptionNorton5Name">
              <strong> {{ norton5Name }}</strong>
            </p>
            <ul aria-labelledby="product1-title" [innerHTML]="getDescriptionNorton5()"></ul>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
      <div class="rs-flex-columns rs-flex-grow rs-order-m1">
        <p>
          {{ 'norton360.subscriptions.addExtraLicense' | translate }}&nbsp;
          <span class="rs-price-s"
            ><span class="rs-nowrap"
              ><span class="rs-euro">€</span><span class="rs-unit">{{ price }}</span></span
            ></span
          >{{ frequency | chargeFrequency }}
        </p>
      </div>
      <div class="rs-flex-columns rs-order-m3">
        <div class="small-only-text-center">
          <a
            href="{{ 'norton360.subscriptions.button.extraLicense.link' | translate }}"
            target="_blank"
            data-tms-event="button-click"
            attr.data-tms-button-zone="{{ 'norton360.subscriptions.title' | translate }}"
            attr.data-tms-button-name="{{
              'norton360.subscriptions.button.extraLicense.label' | translate
            }}"
            class="rs-btn rs-btn-order"
            data-cy="norton360MySubsciptionExtraLicenceButton"
            >{{ 'norton360.subscriptions.button.extraLicense.label' | translate }}</a
          >
        </div>
      </div>
      <div
        class="rs-flex-columns rs-order-m2"
        *ngIf="'norton360.subscriptions.button.cancel.link' | translate"
      >
        <p class="small-only-text-center">
          <a
            href="{{ 'norton360.subscriptions.button.cancel.link' | translate }}"
            target="_blank"
            data-tms-event="link-click"
            attr.data-tms-link-zone="{{ 'norton360.subscriptions.title' | translate }}"
            attr.data-tms-link-name="{{
              'norton360.subscriptions.button.cancel.label' | translate
            }}"
            attr.data-tms-link-url="{{ 'norton360.subscriptions.button.cancel.link' | translate }}"
            data-cy="norton360MySubsciptionCancelButton"
            >{{ 'norton360.subscriptions.button.cancel.label' | translate }}</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
